/**
 * Copyright (c) 2017-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
import { __extends } from "tslib";
import { IntAdjacencyGraph } from '../../../../../mol-math/graph';
import { Unit } from '../../unit';
import { InterUnitGraph } from '../../../../../mol-math/graph/inter-unit-graph';
var IntraUnitBonds;

(function (IntraUnitBonds) {
  IntraUnitBonds.Empty = IntAdjacencyGraph.create([], [], [], 0, {
    flags: [],
    order: []
  });
})(IntraUnitBonds || (IntraUnitBonds = {}));

var InterUnitBonds =
/** @class */
function (_super) {
  __extends(InterUnitBonds, _super);

  function InterUnitBonds() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /** Get inter-unit bond given a bond-location */


  InterUnitBonds.prototype.getBondFromLocation = function (l) {
    return Unit.isAtomic(l.aUnit) && Unit.isAtomic(l.bUnit) ? this.getEdge(l.aIndex, l.aUnit.id, l.bIndex, l.bUnit.id) : undefined;
  };
  /** Get inter-unit bond index given a bond-location */


  InterUnitBonds.prototype.getBondIndexFromLocation = function (l) {
    return Unit.isAtomic(l.aUnit) && Unit.isAtomic(l.bUnit) ? this.getEdgeIndex(l.aIndex, l.aUnit.id, l.bIndex, l.bUnit.id) : -1;
  };

  return InterUnitBonds;
}(InterUnitGraph);

(function (InterUnitBonds) {
  var UnitPairBonds =
  /** @class */
  function (_super) {
    __extends(UnitPairBonds, _super);

    function UnitPairBonds() {
      return _super !== null && _super.apply(this, arguments) || this;
    }

    return UnitPairBonds;
  }(InterUnitGraph.UnitPairEdges);

  InterUnitBonds.UnitPairBonds = UnitPairBonds;
})(InterUnitBonds || (InterUnitBonds = {}));

export { IntraUnitBonds, InterUnitBonds };